// extracted by mini-css-extract-plugin
export var buttonContainer = "_6d-1";
export var fontSizeSelect = "_6d-3";
export var formatSelect = "_6d-2";
export var formats = "_6d-4";
export var hidden = "_6d-5";
export var icon = "_6d-6";
export var select = "_6d-0";